// extracted by mini-css-extract-plugin
export default {"viewMain":"ViewMain_viewMain__qVpHH","buttonGroup":"ViewMain_buttonGroup__oDfYw","link":"ViewMain_link__jR2vX","content":"ViewMain_content__xo3CG"};